import axiosInstance from './axiosInstance';
import { API_ENDPOINTS } from '../config/api.config';

// Everything waiting for the admin, in one call — the home queue and the
// sidebar badges are the SAME numbers because they come from the same place.
export const worklistApi = {
  get: () => axiosInstance.get(API_ENDPOINTS.ANALYTICS.WORKLIST),
};

export default worklistApi;
